import axios from '../../../../utils/request';
// webDetails
function WEB_GET_LIST(params) {
    return axios.post("/statistics/Statistics/infoView",{ id:params } )
}

//flow
function FLOW_GET_LIST(params) {
    return axios.post("/statistics/Statistics/trafficStatistics",{ ...params } )
}

// sourceVisitors
function SOURCE_GET_LIST(params) {
    return axios.post("/statistics/AVisitors/sourceVisitors",{ ...params } )
}
//map
function MAP_GET_LIST(params) {
    return axios.post("/statistics/AAreaStatistics/areaStatistics",{ ...params } )
}
// inquiry
function INQUIRY_GET_LIST(params) {
    return  axios.get("/statistics/Inquiry/inquiryList",{
        params: {
            ...params
        }
    } )
}
function INQUIRY_EXPORT(params) {
    return  axios.get("/statistics/Inquiry/inquiryListExport",{
        params: {
            ...params
        }
    }  )
}
//key
function KEY_GET_LISTALL(params) {
    return  axios.get("/statistics/SiteDetail/seoKeywords",{
        params: {
           ...params
        }
    }  )
}
function KEY_GET_LIST(params) {
    return  axios.get("/statistics/SiteDetail/seoColumn",{
        params: {
            ...params
        }
    }  )
}
export default {
    WEB_GET_LIST,
    FLOW_GET_LIST,
    MAP_GET_LIST,
    SOURCE_GET_LIST,
    INQUIRY_GET_LIST,
    INQUIRY_EXPORT,
    KEY_GET_LISTALL,
    KEY_GET_LIST

};
